import React from 'react'
import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap'

// Import Components
import Screen from '../../../components/accounts/Screen'
import PageTitle from '../../../components/accounts/PageTitle'
import UserCard from '../../../components/accounts/UserCard'

// DEMO DATA
const users = [
  {
    id: 1,
    name: 'Bruce Wayne',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tellus nibh, rutrum eu pellentesque vitae, aliquam ac tellus.',
    skills: 'Node.JS, Python, React',
  },
  {
    id: 2,
    name: 'Clark Kent',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tellus nibh, rutrum eu pellentesque vitae, aliquam ac tellus.',
    skills: 'DevOPS, Angular, TypeScript',
  },
  {
    id: 3,
    name: 'Diana Prince',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tellus nibh, rutrum eu pellentesque vitae, aliquam ac tellus.',
    skills: 'Django, PHP',
  },
  {
    id: 4,
    name: 'Anthony Stark',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tellus nibh, rutrum eu pellentesque vitae, aliquam ac tellus.',
    skills: 'Python, Machine Learning, AI',
  },
  {
    id: 5,
    name: 'Steve Rogers',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tellus nibh, rutrum eu pellentesque vitae, aliquam ac tellus.',
    skills: 'Node.JS, Python, React',
  },
]

const JobDetail = () => {
  return (
    <Screen>
      <PageTitle title='Mobile Developer' />
      <Container fluid className='p-0 job-detail'>
        <Row>
          <Col md={12}>
            <Card className='p-3'>
              <Card.Body>
                <Card.Title>
                  <b>Mobile Developer</b>
                </Card.Title>
                <hr />
                <div className='mb-4'>
                  <h6>Description</h6>
                  <p>
                    An emerging software start-up targeting the travel and
                    hospitality industry is looking to hire an experienced
                    mobile developer who will create applications for their
                    users. You will be responsible for scoping technical
                    requirements and delivering impactful features by working
                    closely with the founders and designers. You will be
                    responsible for scoping technical requirements and
                    delivering impactful features by working closely with the
                    founders and designers.
                  </p>
                </div>
                <div className='mb-4'>
                  <h6>Additional Requirements:</h6>
                  <p>Kubernetes/Docker, JavaScript/TypeScript</p>
                </div>
                <div className='mb-4'>
                  <h6>Where will you work?</h6>
                  <p>
                    This position will be entirely remote. You will get to
                    experience a company that believes in small teams for
                    maximum impact; seeks well-rounded talent to ensure a full
                    perspective on our customers’ experience, understands that
                    this is a marathon, not a sprint; that continuously and
                    purposefully builds an inclusive culture where everyone is
                    able to do and be the best version of themselves.
                  </p>
                  <p>
                    We are committed to equal opportunity regardless of race,
                    color, ancestry, religion, gender, gender identity, parental
                    or pregnancy status, national origin, sexual orientation,
                    age, citizenship, marital status, disability, or veteran
                    status.
                  </p>
                </div>
                <Row className='mb-3'>
                  <Col md={4}>
                    <h6>Job Role</h6>
                    <p>Mobile Developer</p>
                  </Col>
                  <Col md={4}>
                    <h6>Level</h6>
                    <p>Export Level</p>
                  </Col>
                </Row>
                <div>
                  <h6>Skills</h6>
                  <Badge variant='primary'>Java</Badge>{' '}
                  <Badge variant='primary'>IOS</Badge>{' '}
                  <Badge variant='primary'>JavaScript</Badge>{' '}
                  <Badge variant='primary'>Python</Badge>{' '}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col md={12}>
            <h4>
              List of Suitable Engineers (this list will only be visible to)
              Recureters
            </h4>
            <hr />
          </Col>
          {users &&
            users.map((user) => (
              <Col md={4}>
                <UserCard key={user.id} user={user} />
              </Col>
            ))}
        </Row>
      </Container>
    </Screen>
  )
}

export default JobDetail
